import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {translate} from "react-i18next"

import {dateToString} from "../../utils"

import styles from "./styles.css"

class NotificationList extends PureComponent {
  static propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.object),
    onClick: PropTypes.func
  }

  static defaultProps = {
    notifications: [],
    onClick: (_path, _notification) => {}
  }

  _onClick(notification) {
    const permalink = this._getPermalink(notification)
    if (!permalink) return

    this.props.onClick(permalink, notification)
  }

  _getPermalink(notification) {
    switch (notification.type) {
      case "learning_module":
        return `/${notification.lang}/learning/topic/${
          notification.data.topic_id
        }#module-${notification.data.module_id}`

      case "learning_topic":
        return `/${notification.lang}/learning/topic/${
          notification.data.topic_id
        }`

      case "learning_article":
      case "knowledge_article":
        return new URL(notification.data.permalink).pathname

      case "knowledge_comment_role":
      case "knowledge_comment":
        return `${new URL(notification.data.permalink).pathname}#comment-${
          notification.data.comment_id
        }`

      default:
        return null
    }
  }

  renderNotificationKnowledgeComment(notification) {
    const {t} = this.props

    return (
      <p className="knowledge" onClick={() => this._onClick(notification)}>
        <span className="label">{t("Neue Antwort auf deinen Kommentar")}</span>
        <span
          className="title"
          dangerouslySetInnerHTML={{__html: notification.data.post_title}}
        />
        <span className="date">
          {dateToString(notification.created_at)}, von{" "}
          {notification.data.by_user}
        </span>
      </p>
    )
  }

  renderNotificationKnowledgeCommentRole(notification) {
    const {t} = this.props

    return (
      <p className="knowledge" onClick={() => this._onClick(notification)}>
        <span className="label">{t("Neuer Kommentar in der Bibliothek")}</span>
        <span
          className="title"
          dangerouslySetInnerHTML={{__html: notification.data.post_title}}
        />
        <span className="date">
          {dateToString(notification.created_at)}, von{" "}
          {notification.data.by_user}
        </span>
      </p>
    )
  }

  renderNotificationKnowledgeArticle(notification) {
    const {t} = this.props

    return (
      <p className="knowledge" onClick={() => this._onClick(notification)}>
        <span className="label">{t("Neuer Artikel in der Bibliothek")}</span>
        <span
          className="title"
          dangerouslySetInnerHTML={{__html: notification.data.post_title}}
        />
        <span className="date">{dateToString(notification.created_at)}</span>
      </p>
    )
  }

  renderNotificationLearningArticle(notification) {
    const {t} = this.props

    return (
      <p className="learning" onClick={() => this._onClick(notification)}>
        <span
          className="label"
          dangerouslySetInnerHTML={{
            __html: t("Neuer Artikel in Modul '{{- module}}'", {
              module: notification.data.module_name
            })
          }}
        />
        <span
          className="title"
          dangerouslySetInnerHTML={{__html: notification.data.post_title}}
        />
        <span className="date">{dateToString(notification.created_at)}</span>
      </p>
    )
  }

  renderNotificationLearningModule(notification) {
    const {t} = this.props

    return (
      <p className="learning" onClick={() => this._onClick(notification)}>
        <span
          className="label"
          dangerouslySetInnerHTML={{
            __html: t("Neues Modul in Kurs '{{- topic}}'", {
              topic: notification.data.topic_name
            })
          }}
        />
        <span
          className="title"
          dangerouslySetInnerHTML={{__html: notification.data.module_name}}
        />
        <span className="date">{dateToString(notification.created_at)}</span>
      </p>
    )
  }

  renderNotificationLearningTopic(notification) {
    const {t} = this.props

    return (
      <p className="learning" onClick={() => this._onClick(notification)}>
        <span className="label">{t("Neuer Kurs in der Akademie")}</span>
        <span
          className="title"
          dangerouslySetInnerHTML={{__html: notification.data.topic_name}}
        />
        <span className="date">{dateToString(notification.created_at)}</span>
      </p>
    )
  }

  renderNotificationDefault(_notification) {
    return <span>Notification (unknown)</span>
  }

  renderNotification(notification) {
    switch (notification.type) {
      case "knowledge_comment_role":
        return this.renderNotificationKnowledgeCommentRole(notification)

      case "knowledge_comment":
        return this.renderNotificationKnowledgeComment(notification)

      case "knowledge_article":
        return this.renderNotificationKnowledgeArticle(notification)

      case "learning_article":
        return this.renderNotificationLearningArticle(notification)

      case "learning_module":
        return this.renderNotificationLearningModule(notification)

      case "learning_topic":
        return this.renderNotificationLearningTopic(notification)

      default:
        return this.renderNotificationDefault(notification)
    }
  }

  render() {
    const {notifications, t} = this.props

    if (notifications.length === 0) {
      return (
        <p className="no-entries">{t("Du hast keine Benachrichtigungen")}</p>
      )
    }

    return (
      <ul className={`${styles.List} notification-list`}>
        {notifications.map(notification => {
          return (
            <li
              key={`notification-${notification.id}`}
              className={!notification.read_at ? "new" : undefined}
            >
              {this.renderNotification(notification)}
            </li>
          )
        })}
      </ul>
    )
  }
}

export default translate()(NotificationList)



// WEBPACK FOOTER //
// ./src/components/NotificationList/index.js